"use strict";

var Environment   = require('./Environment');
var emptyFunction = require('react/lib/emptyFunction');

/**
 * Dummy routing environment which provides no path.
 *
 * Should be used on server or in WebWorker.
 */
function DummyEnvironment() {
  Environment.call(this);
}

DummyEnvironment.prototype = Object.create(Environment.prototype);
DummyEnvironment.prototype.constructor = DummyEnvironment;

DummyEnvironment.prototype.getPath = emptyFunction.thatReturnsNull;

DummyEnvironment.prototype.setPath = function(path, navigation, cb) {
  // Support old (path, cb) arity
  if (typeof navigation === 'function' && cb === undefined) {
    cb = navigation;
    navigation = {};
  }
  this.path = path;
  cb();
};

DummyEnvironment.prototype.start = emptyFunction;

DummyEnvironment.prototype.stop = emptyFunction;

module.exports = DummyEnvironment;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-component/lib/environment/DummyEnvironment.js
 ** module id = 217
 ** module chunks = 0
 **/